import { render, staticRenderFns } from "./char-message-textarea.vue?vue&type=template&id=6b972b1a&scoped=true"
import script from "./char-message-textarea.vue?vue&type=script&lang=js"
export * from "./char-message-textarea.vue?vue&type=script&lang=js"
import style0 from "./char-message-textarea.vue?vue&type=style&index=0&id=6b972b1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b972b1a",
  null
  
)

export default component.exports